import { readJson } from '@ms-cloudpack/json-utilities';
import { getConfigPath } from '../getConfigPath.js';
import type { GeneratedConfig } from '@ms-cloudpack/common-types';

/**
 * Reads the generated config file asynchronously. This is only useful for the `init` verb generating or updated
 * the generated settings. For a full merged representation of config, use `readConfig` instead.
 *
 * Throws an error if the config file exists but is not valid JSON (or there's some error reading it).
 */
export async function readGeneratedConfig(appPath: string): Promise<GeneratedConfig> {
  const { generatedConfigPath } = getConfigPath(appPath);

  return (await readJson(generatedConfigPath, { throwOnError: true, mode: 'permissive' })) || {};
}
